import * as FilePond from 'filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginGetFile from 'filepond-plugin-get-file';
import FilePondPluginPdfPreview from "filepond-plugin-pdf-preview";

(function (cash) {
    "use strict";

    FilePond.registerPlugin(FilePondPluginImagePreview);
    FilePond.registerPlugin(FilePondPluginFileValidateSize);
    FilePond.registerPlugin(FilePondPluginGetFile);
    FilePond.registerPlugin(FilePondPluginPdfPreview);
    FilePond.registerPlugin(FilePondPluginFileValidateType);

    window.FilePond = FilePond;

    if (cash("#mouvement_upload").length && false) {
        // Create a multi file upload component
        const pond = FilePond.create({
            multiple: true,
            name: 'filepond',
            acceptedFileTypes: ['image/jpg', 'image/jpeg', 'image/png', 'image/gif','application/pdf','application/x-pdf']
        });

        // Add it to the DOM
        cash("#mouvement_upload").find('.filepond-container')[0].appendChild(pond.element);
    }
})(cash);
